import { systemSetting } from '@/router/systemSetting';
export const COMMON = {
  PAGE_SIZE: 20,
  PAGE_NUM: 1
};
export const ACTION_TYPES = [
  // 增删改查
  { title: '创建', value: 'create' },
  { title: '删除', value: 'delete' },
  { title: '修改', value: 'update' },
  { title: '查看', value: 'search' },
  { title: '其他', value: 'other' }
];
export const ACTION_LABELS = {
  // 增删改查
  create: '创建',
  delete: '删除',
  update: '修改',
  search: '查看',
  other: '其他'
};
export const fileSuffix = [
  // 文档类型
  { type: 'pdf', strs: 'docx,doc,odt,ott,sxw,rtf,wpd,html,txt,ods,ots,sxc,csv,tsv,pptx,ppt,odp,otp,sxi,pdf,js' },
  { type: 'image', strs: 'jpg,jpeg,png,gif,bmp,ico,raw' },
  { type: 'video', strs: 'avi,mov,rmvb,rm,flv,mp4,3gp' },
  { type: 'audio', strs: 'mp3,m4a' },
  { type: 'excel', strs: 'xlsx,xls' },
  { type: 'ziprar', strs: 'zip,rar' },
  { type: 'miaoji', strs: '飞书妙记,' }
];
export const SYSTEM_SETTING_ASIDELIST = [
  {
    title: '系统管理',
    name: 'system',
    icon: 'setting',
    list: [
      {
        title: '菜单权限管理',
        path: '/systemSetting/manage/menuPower'
      },
      {
        title: '操作记录',
        path: '/systemSetting/opLog'
      }
    ]
  },
  {
    title: '个人管理',
    name: 'info',
    icon: 'idcard',
    list: [
      {
        title: '基本信息',
        path: '/systemSetting/info/trace'
      }
    ]
  },
  {
    title: '用户管理',
    name: 'user',
    icon: 'user',
    list: [
      {
        title: '用户管理',
        path: '/systemSetting/manage/user'
      },
      {
        title: '角色权限管理',
        path: '/systemSetting/manage/rolePower'
      },
      {
        title: '部门角色管理',
        path: '/systemSetting/manage/departmentRole'
      }
    ]
  },
  {
    title: '项目管理',
    name: 'project',
    icon: 'project',
    list: [
      {
        title: '项目阶段管理',
        path: '/systemSetting/manage/projectProgress'
      },
      {
        title: '行业领域管理',
        path: '/systemSetting/manage/sector'
      },
      {
        title: '公司标签管理',
        path: '/systemSetting/manage/projectTags/company'
      },
      {
        title: 'notes标签管理',
        path: '/systemSetting/manage/projectTags/notes'
      },
      {
        title: '项目文档类型管理',
        path: '/systemSetting/manage/documentType'
      },
      {
        title: '项目轮次管理',
        path: '/systemSetting/manage/round'
      },
      {
        title: '策略标签管理',
        path: '/systemSetting/manage/strategyTag'
      },
      {
        title: '标签关系管理',
        path: '/systemSetting/manage/strategyTagRelation'
      }
    ]
  },
  {
    title: '运营管理',
    name: 'operate',
    icon: 'schedule',
    list: [
      {
        title: '提醒设置',
        path: '/systemSetting/notice'
      },
      {
        title: '交割项目贡献管理',
        path: '/systemSetting/manage/projectContribution'
      },
      {
        title: '北京交易贡献管理',
        path: '/systemSetting/manage/financeProjectContribution'
      },
      {
        title: '北京交易Vote管理',
        path: '/systemSetting/manage/financeProjectVote'
      },
      {
        title: '项目品质评价管理',
        path: '/systemSetting/manage/projectQuality'
      }
    ]
  }
];
export const USER_STATUS = status => {
  // 用户状态
  // 0正常 -1冻结 -2删除
  return status === 0 ? '正常' : status === -1 ? '冻结' : status === -2 ? '删除' : '---';
};
export const MENU_STATUS = status => {
  // 菜单状态
  // 0正常，-1冻结
  return +status === 0 ? '正常' : +status === -1 ? '冻结' : '---';
};
export const MENU_TYPE = type => {
  // 菜单类型
  // 0页面，1操作权限
  return +type === 0 ? '页面' : +type === 1 ? '操作' : +type === 2 ? '内页' : '---';
};
export const DOCUMENT_TYPE_STATUS = status => {
  return +status === 0 ? '使用中' : +status === -1 ? '已禁用' : '---';
};
export const ASYNC_ROUTERS = {
  path: '',
  component: () => import('@/components/layout'),
  redirect: '/',
  children: [
    {
      path: '/',
      component: () => import(/* webpackChunkName: "home" */ '@/views/home.vue')
    },
    {
      path: '/person',
      component: () => import(/* webpackChunkName: "person" */ '@/views/person.vue')
    },
    {
      path: '/project',
      component: () => import(/* webpackChunkName: "project" */ '@/views/project/list.vue')
    },
    {
      path: '/project/detail',
      component: () => import(/* webpackChunkName: "projectDetail" */ '@/views/project/detail.vue')
    },
    {
      path: '/meeting',
      component: () => import(/* webpackChunkName: "meeting" */ '@/views/meeting/index.vue')
    },
    {
      path: '/document',
      component: () => import(/* webpackChunkName: "document" */ '@/views/document/index.vue')
    },
    {
      path: '/data',
      component: () => import(/* webpackChunkName: "data" */ '@/views/data/index.vue')
    },
    {
      path: '/systemSetting',
      redirect: systemSetting[0].path,
      component: () => import(/* webpackChunkName: "systemSettingIndex" */ '@/views/systemSetting/index'),
      children: systemSetting
    }
  ]
};
export const CONST_ROUTERS = [
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login.vue')
  },
  // {
  //   path: '/picture',
  //   component: () => import(/* webpackChunkName: "picture" */ "@/views/picture.vue")
  // },
  {
    path: '/search',
    component: () => import(/* webpackChunkName: "systemSettingIndex" */ '@/views/search')
  }
];
export const VENTRURE_SOURCE_TYPES = [
  {
    id: 1,
    name: '公司首轮融资+不是FA推荐'
  },
  {
    id: 2,
    name: '公司不融资，DT说服公司融资'
  },
  {
    id: 3,
    name: '公司非首轮融资+不是FA推荐'
  },
  {
    id: 4,
    name: 'FA推荐'
  }
];
